/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 支払通知書アップロード完了リクエスト
 * @export
 * @interface CompleteOperationNoticeUploadRequest
 */
export interface CompleteOperationNoticeUploadRequest {
    /**
     * confirmUploadで払い出されたoperation_upload_id
     * @type {string}
     * @memberof CompleteOperationNoticeUploadRequest
     */
    operationUploadId: string;
}

/**
 * Check if a given object implements the CompleteOperationNoticeUploadRequest interface.
 */
export function instanceOfCompleteOperationNoticeUploadRequest(value: object): value is CompleteOperationNoticeUploadRequest {
    if (!('operationUploadId' in value) || value['operationUploadId'] === undefined) return false;
    return true;
}

export function CompleteOperationNoticeUploadRequestFromJSON(json: any): CompleteOperationNoticeUploadRequest {
    return CompleteOperationNoticeUploadRequestFromJSONTyped(json, false);
}

export function CompleteOperationNoticeUploadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteOperationNoticeUploadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'operationUploadId': json['operation_upload_id'],
    };
}

export function CompleteOperationNoticeUploadRequestToJSON(json: any): CompleteOperationNoticeUploadRequest {
    return CompleteOperationNoticeUploadRequestToJSONTyped(json, false);
}

export function CompleteOperationNoticeUploadRequestToJSONTyped(value?: CompleteOperationNoticeUploadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation_upload_id': value['operationUploadId'],
    };
}

